module.exports = __webpack_public_path__ + "img/main.889bac0a.jpg";